import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from '@/store/store'
import filters from '@/filters'
import './plugins/global-components'
import 'driver.js/dist/driver.css'
import SnackbarMixin from './mixins/snackbarMixin'
import Confirm from './extensions/confirm'

Vue.config.productionTip = false
Vue.mixin(SnackbarMixin)
Vue.use(Confirm, { vuetify })
filters.install(Vue)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app')
